import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { billingAndShippingStyles } from "@insite/content-library/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartTotalStyles.checkoutButton = {
    typographyProps: {
        color: "black",
    },
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                    `,
                    css`
                        width: 100%;
                        margin-top: 10px;
                        position: inherit;
                        left: inherit;
                        bottom: inherit;
                    `,
                ],
                "min",
            )}
    `,
};

billingAndShippingStyles.billToText = {
    css: css`
        width: 100%;
    `,
};
